import React from "react";
import UnconfirmedMessage from "components/shared/ProductOnboarding/UnconfirmedMessage";
import BankRelinking from "components/shared/ProductOnboarding/BankRelinking";
import PendingMessage from "components/shared/ProductOnboarding/PendingMessage";
import Loading from "components/ui/Loading";
import { getUserProfile } from "store/api/apiSlice";
import { EligibilityCriteria } from "utils/api/cardApplication";

interface Props {
  actionableCriteria: EligibilityCriteria[];
  setIsPolling: (isPolling: boolean) => void;
}

const EligibilityResolution: React.FC<Props> = ({
  actionableCriteria,
  setIsPolling,
}) => {
  const { data: userProfile } = getUserProfile({ pollingInterval: 5_000 });

  if (!userProfile) return <Loading />;

  const hasLinkedPayroll = userProfile?.linkedPayroll;

  // If the user has linked payroll, linking a different bank won't resolve positive earnings
  // In that case we'll pass through to the generic pending message
  const canBeResolvedByLinkingDifferentBank = actionableCriteria.some(
    (criteria) =>
      criteria === EligibilityCriteria.positiveEarnings ||
      criteria === EligibilityCriteria.nonNeoBank
  );
  if (!hasLinkedPayroll && canBeResolvedByLinkingDifferentBank)
    return (
      <BankRelinking
        actionableCriteria={actionableCriteria}
        setIsPolling={setIsPolling}
        userProfile={userProfile}
      />
    );

  if (actionableCriteria.includes(EligibilityCriteria.confirmedEmail))
    return <UnconfirmedMessage />;
  if (actionableCriteria.includes(EligibilityCriteria.confirmedEmail))
    return <UnconfirmedMessage />;

  // The above criteria should be the only blocking ones, but we'll show a generic message if the user's application still has 'requires_action' status
  return <PendingMessage />;
};

export default EligibilityResolution;
